export class EventInfo {
    status: string;
    animationState: string;
    scoring_name: string;
    group_event_id: string;
    nbr_of_holes: string;
    group_id: string;
    group_name: string;
    event_date: string;
    name: string;
    player_count: string;
    is_multi_round: string;
    multi_round_id: string;
    is_browsable: string;
    is_ryder_cup: string;
    course_id: string;
    coursename: string;
    tees_id: string;
    slope: string;
    rating: string;
    pars: number[];
    yards: number[];
    hcps: number[];
    yards_1: string;
    yards_2: string;
    yards_3: string;
    yards_4: string;
    yards_5: string;
    yards_6: string;
    yards_7: string;
    yards_8: string;
    yards_9: string;
    yards_10: string;
    yards_11: string;
    yards_12: string;
    yards_13: string;
    yards_14: string;
    yards_15: string;
    yards_16: string;
    yards_17: string;
    yards_18: string;
    par_1: string;
    hdcp_1: string;
    par_2: string;
    hdcp_2: string;
    par_3: string;
    hdcp_3: string;
    par_4: string;
    hdcp_4: string;
    par_5: string;
    hdcp_5: string;
    par_6: string;
    hdcp_6: string;
    par_7: string;
    hdcp_7: string;
    par_8: string;
    hdcp_8: string;
    par_9: string;
    hdcp_9: string;
    par_10: string;
    hdcp_10: string;
    par_11: string;
    hdcp_11: string;
    par_12: string;
    hdcp_12: string;
    par_13: string;
    hdcp_13: string;
    par_14: string;
    hdcp_14: string;
    par_15: string;
    hdcp_15: string;
    par_16: string;
    hdcp_16: string;
    par_17: string;
    hdcp_17: string;
    par_18: string;
    hdcp_18: string;
    event_scoring: string;
    event_type: string;
    registration_start: string;
    registration_end: string;
}
